const ElementsWrapper = props => props.children;

export default ElementsWrapper;
